"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var clsx_1 = __importDefault(require("clsx"));
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var Typography_1 = __importDefault(require("../Typography"));
var FormControlHelpText_1 = __importDefault(require("./FormControlHelpText"));
var FormControlSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ", ";\n  font-family: ", ";\n\n  ._ndsFormControl__label {\n    user-select: none;\n    margin-bottom: 0.25rem;\n    color: ", ";\n  }\n\n  ._ndsFormControl__label__input,\n  ._ndsFormControl__label__optional {\n    color: inherit;\n  }\n\n  ._ndsFormControl__label__optional {\n    margin-left: 0.5rem;\n  }\n\n  /* hover */\n  &:hover {\n    ._ndsFormControl__label__input {\n      color: ", ";\n    }\n  }\n\n  /* disabled */\n  &._ndsFormControl--disabled {\n    user-select: none;\n    ._ndsFormControl__label__input,\n    ._ndsFormControl__label__optional {\n      color: ", ";\n    }\n  }\n\n  /* error */\n  &._ndsFormControl--error {\n    ._ndsFormControl__label__input {\n      color: ", ";\n    }\n  }\n\n  /* disabled & error */\n  &._ndsFormControl--disabled._ndsFormControl--error {\n    ._ndsFormControl__label__optional {\n      color: inherit;\n    }\n  }\n\n  &._ndsFormControl--fullWidth {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n  }\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ", ";\n  font-family: ", ";\n\n  ._ndsFormControl__label {\n    user-select: none;\n    margin-bottom: 0.25rem;\n    color: ", ";\n  }\n\n  ._ndsFormControl__label__input,\n  ._ndsFormControl__label__optional {\n    color: inherit;\n  }\n\n  ._ndsFormControl__label__optional {\n    margin-left: 0.5rem;\n  }\n\n  /* hover */\n  &:hover {\n    ._ndsFormControl__label__input {\n      color: ",
    ";\n    }\n  }\n\n  /* disabled */\n  &._ndsFormControl--disabled {\n    user-select: none;\n    ._ndsFormControl__label__input,\n    ._ndsFormControl__label__optional {\n      color: ",
    ";\n    }\n  }\n\n  /* error */\n  &._ndsFormControl--error {\n    ._ndsFormControl__label__input {\n      color: ",
    ";\n    }\n  }\n\n  /* disabled & error */\n  &._ndsFormControl--disabled._ndsFormControl--error {\n    ._ndsFormControl__label__optional {\n      color: inherit;\n    }\n  }\n\n  &._ndsFormControl--fullWidth {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n  }\n"])), function (p) { return p.theme.SizeMarginInputBottom; }, function (p) { return p.theme.FontFamilyBase; }, function (p) { return p.theme.ColorFontInputLabelBase; }, function (props) {
    return props.theme.ColorFontInputLabelHover;
}, function (props) {
    return props.theme.ColorFontInputLabelDisabled;
}, function (props) {
    return props.theme.ColorFontInputLabelError;
});
var FormControl = function (props) {
    var label = props.label, helpTextId = props.helpTextId, children = props.children, forwardedRef = props.forwardedRef, classNameProp = props.className, disabled = props.disabled, error = props.error, required = props.required, fullWidth = props.fullWidth, inputId = props.inputId, helpText = props.helpText, others = __rest(props, ["label", "helpTextId", "children", "forwardedRef", "className", "disabled", "error", "required", "fullWidth", "inputId", "helpText"]);
    var classes = clsx_1.default('_ndsFormControl', { '_ndsFormControl--error': error === true }, { '_ndsFormControl--disabled': disabled === true }, { '_ndsFormControl--fullWidth': fullWidth === true }, classNameProp);
    return (react_1.default.createElement(FormControlSC, __assign({ ref: forwardedRef, className: classes }, others),
        react_1.default.createElement("div", { className: "_ndsFormControl__label" },
            react_1.default.createElement(Typography_1.default, { as: "label", htmlFor: inputId, className: "_ndsFormControl__label__input", variant: "subhead1" }, label),
            !required && (react_1.default.createElement(Typography_1.default, { as: "label", className: "_ndsFormControl__label__optional", variant: "body4" }, "Optional"))),
        children,
        react_1.default.createElement(FormControlHelpText_1.default, { helpText: helpText, helpTextId: helpTextId, error: error, disabled: disabled })));
};
FormControl.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]).isRequired,
    forwardedRef: prop_types_1.default.any,
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    error: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    fullWidth: prop_types_1.default.bool,
    inputId: prop_types_1.default.string,
    helpTextId: prop_types_1.default.string,
    label: prop_types_1.default.string,
    helpText: prop_types_1.default.any
};
FormControl.defaultProps = {
    label: undefined,
    helpText: undefined,
    forwardedRef: react_1.default.createRef(),
    className: undefined,
    disabled: false,
    error: false,
    fullWidth: false,
    required: false,
    inputId: undefined,
    helpTextId: undefined
};
exports.default = reactHelpers_1.withForwardedRef(FormControl);
var templateObject_1;
//# sourceMappingURL=FormControl.js.map